import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const redirectionView = () =>
    import('@/components/redirection/redirection.view')
// Containers
const MainTemplate = () =>
    import('@/components/MainTemplate/MainTemplate')
const LoginView = () =>
    import('@/views/Login')
const UsuariosView = () =>
    import('@/components/usuarios/usuarios.view')
const OficiosView = () =>
    import('@/components/oficios/oficios.view')
const ConsultarOficioView = () =>
    import('@/views/consultarOficio')
// const PermisosView = () =>
//     import('@/views/permisos')
const DependenciasView = () =>
    import('@/views/dependencias')
const IntegrantesDependenciaView = () =>
    import('@/views/integrantesDependencia')
const EntidadesView = () =>
    import('@/views/entidades')
// const CentrosView = () =>
//     import('@/views/centros')
const SolicitudView = () =>
    import('@/views/verSolicitud')
// Depara
const ConsultarDeparaView = () =>
    import('@/components/depara/depara.view')
const ArchivoView = () => import('@/views/archivo.vue')
const MisOficios = () => import ('@/views/misOficios.vue')
const MisOficiosVista = () => import ('@/views/vistaMisOficios.vue')
const VistaOficios = () => import('@/components/oficios/vistaOficios')
const ListadoDePara = () => import('@/components/depara/listadoDepara.vue')

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        { path: '/redirect/:token', name: 'Redirect', component: redirectionView },
        { path: '/', redirect: '/login' },
        {
            path: '/',
            redirect: '/oficios',
            name: 'Home',
            component: MainTemplate,
            children: [{
                path: 'oficios',
                name: 'Oficios',
                component: OficiosView,
                redirect: () => {
                    return { path: 'oficios/Entrantes', query: { page: 1, search:"", filter:0, words:"false" } }
                  },
                children: [{
                    path: ':tipo',
                    name: 'vista',
                    component: VistaOficios
                },
                // {
                //     path: '/DePara',
                //     name: 'depara',
                //     component: ListadoDePara
                // },
            ]
            },
            {
                path: 'misOficios',
                name: 'Mis Oficios',
                redirect: () => {
                    return { path: 'misOficios/Entrantes', query: { page: 1,search:"",filter:0 } }
                  },
                component: MisOficios,
                children: [
                    {
                        path: ':tipo',
                        name: 'Tipo de oficio',
                        component: MisOficiosVista
                    },
                    
                ]
            },
            {
                path: 'oficios/:tipo/:id',
                name: 'Consultar oficio',
                component: ConsultarOficioView
            },
            {
                path: 'usuarios',
                name: 'Usuarios',
                component: UsuariosView
            },
            // {
            //     path: 'permisos',
            //     name: 'Permisos',
            //     component: PermisosView
            // },
            {
                path: 'dependencias',
                name: 'Dependencias',
                component: DependenciasView
            },
            {
                path: 'dependencias/:id',
                name: 'Integrantes dependencia',
                component: IntegrantesDependenciaView
            },
            {
                path: 'entidades',
                name: 'Entidades',
                component: EntidadesView
            },
            // {
            //     path: 'centros',
            //     name: 'Centros Universitarios',
            //     component: CentrosView
            // },
            {
                path: 'centros/solicitud/:id',
                name: 'Consultar solicitud',
                component: SolicitudView
            },
            // Depara route
            {
                path: 'depara/:id',
                name: 'Consultar depara',
                component: ConsultarDeparaView
            },
            {
                path: 'archivo',
                name: 'Archivo',
                component: ArchivoView,
            }
            ]
        },
        { path: '/login', name: 'Login', component: LoginView },
        { path:  '*', redirect:'/login'}
    ]
})